import { request  } from '../utils';
import store from '../store';

export default function zan(data, calback) {
    cancelFollow(data, calback);
}

function cancelFollow(data: any, calback: any) {
    let dataObj: any = {
        partnerId: store.user.partnerId,
        saveUrl: data.saveUrl,
        source: data.source,
        page: data.page,
        gameId: data.gameId || '',
        productId: data.productId,
        specialName:data.specialName || ''
    }
    if (!data.gameId) {
        delete dataObj.gameId
    }
    if(!data.productId){
        delete dataObj.productId
    }
    request('user/store/v1/visitor/save', dataObj).then((rd) => {
        if (rd.errCode == 200) {
            sessionStorage.setItem('isSave','true')
            calback && calback(false);
        } else {
            calback && calback(true);
        }
    });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/operates/visitorSave.ts